import styled, { css } from 'styled-components'

export const BarrierStatusNameStyled = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    border: none;
    justify-self: center;
    /* align-items: center; */

    .separator {
        content: '';
        margin-top: 9px;
        border-bottom: 1px solid var(--gray-400);
    }

    .barrier-status-name-title {
        color: var(--gray-800);
        font-size: 14px;
        line-height: 24px;
        padding-top: 32px;

        text-transform: uppercase;
        font-family: var(--font-bold);
        border-bottom: 1px solid var(--gray-400);
        display: flex;

        /* font-family: 'Source Sans Pro';
        font-style: normal;
        font-weight: 600; */
    }
    .barrier-status-edit-icon {
        margin-left: auto;
        color: var(--blue-500);
        font-size: 16px;
        cursor: pointer;
        padding-right: 4px;
        padding-left: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 24px;

        &.editing {
            display: none;
        }
    }
    .barrier-status-name-subtitle {
        color: var(--gray-700);
        font-size: 13px;
        line-height: 16px;

        font-family: var(--font-regular);
        padding-top: 12px;
        display: flex;
        .barrier-status-attention {
            font-family: var(--font-bold);
            padding-right: 2px;
        }
    }
    .barrier-status-container {
        height: 100%;
        padding: 0 0 13px 0;
        display: flex;
        flex-direction: column;

        .barrier-status-header {
            display: grid;
            grid-template-columns: 40px 1fr min-content;
            gap: 32px;
            margin-top: 36px;
            border-bottom: 1px solid var(--gray-400);

            &.editing {
                background: var(--gray-200);
                margin-left: -15px;
                margin-rigth: -15px;
            }

            .barrier-status-header-tag {
                /* padding-left: 32px;
                padding-right: 32px; */
                padding-top: 8px;
                padding-bottom: 8px;
                font-family: var(--font-bold);
                color: var(--gray-700);
                font-size: 12px;
                line-height: 11px;
                text-transform: uppercase;
                &.color-editing {
                    padding-left: 15px;
                }
                &.name-editing {
                    padding-left: 15px;
                }
            }
        }

        .barrier-status-content {
            padding: 12px 0px;

            .barrier-status-item-wrapper {
                .barrier-status {
                    display: grid;
                    grid-template-areas: 'COL NAM DLT';
                    grid-template-rows: 32px;
                    grid-template-columns: min-content min-content min-content;

                    padding: 12px 0px;

                    .color-box {
                        width: 32px;
                        height: 32px;
                        content: '';
                        background-color: green;
                        margin: auto;
                        grid-area: COL;
                    }

                    .color-picker-wrapper {
                        position: relative;
                        .fa-edit {
                            position: absolute;
                            top: 17px;
                            right: 0;
                            z-index: 3;
                        }
                    }

                    .barrier-status-custom-name-input-span {
                        grid-area: NAM;
                        margin: 0px 0px 0px 40px;

                        .barrier-status-custom-name-input {
                            border: 1px solid var(--gray-300);
                            border-radius: 3px 3px 0px 0px;
                            background: var(--gray-0);
                            font-family: var(--font-regular);
                            font-size: 13px;
                            line-height: 16px;
                            width: 185px;

                            &.disabled {
                                background: var(--gray-100);
                            }
                            &.red-border {
                                border-color: var(--red-700);
                            }
                        }

                        .default-name-span {
                            color: var(--gray-700);
                            font-size: 12px;
                            font-weight: 400;
                        }
                    }
                    .delete-icon {
                        grid-area: DLT;
                        display: flex;
                        align-items: center;
                        margin-left: 8px;

                        .fa-trash-alt {
                            font-size: 16px;
                            font-weight: 400;
                            color: var(--red-700);
                            cursor: pointer;
                            &.in-use {
                                color: var(--red-300);
                                cursor: default;
                            }
                        }
                    }
                }

                .new-status-row {
                    display: none;
                    &.focus {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        font-size: 13px;
                    }
                    .new-status-line {
                        height: 1px;
                        width: 80px;
                        background: var(--gray-400);
                    }
                    .new-status-button {
                        color: var(--blue-700);
                        display: flex;
                        align-items: center;
                        gap: 10px;
                    }
                }
            }
        }
    }

    .barrier-status-table-header th {
        padding-bottom: 0px;
        border-bottom: 1px solid var(--gray-400);
    }

    .save-bar {
        background: var(--gray-200);
        font-size: 15px;
        line-height: 16px;
        color: var(--gray-1000);
        font-family: var(--font-regular);
        display: flex;
        align-items: center;
        padding: 8px;
        margin-bottom: 16px;

        &.editing {
            margin-left: -15px;
        }

        .save-button {
            color: var(--gray-0);
            background: var(--blue-500);
            font-family: var(--font-bold);
            font-size: 13px;
            line-height: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 4px 16px;
            gap: 8px;
            width: 61px;
            height: 24px;
            border-radius: 3px;
            border: none;
            border-color: var(--blue-500);
            margin-right: 8px;
        }
        .cancel-button {
            margin-left: 8px;
            color: var(--blue-500);
            font-family: var(--font-regular);
            font-size: 13px;
            line-height: 16px;
            cursor: pointer;
        }
    }
    .background-head-color {
        content: '';
        display: flex;
        flex-direction: row;
        width: 90%;
        margin-left: 5%;
        height: 28px;
        margin-top: 28px;
        margin-bottom: -41px;
    }

    /* .row-0 th {
        padding-top: 26px;
    } */
    .edditing-head {
        background: var(--gray-200);
        border-bottom: var(--gray-300);
        border-bottom: 1px solid var(--gray-400);
    }
`
